module.exports = __webpack_public_path__ + "img/img_default.fcde4e88.png";